import Deposit from './models/Deposit'
import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

var serverUrl = '/api/'
if (window.location.host === 'localhost:8080') {
  serverUrl = 'https://www.cnypay.today/api/'
}

const models = {
  Deposit
}
export default {
  install (Vue) {
    Vue.prototype.$models = models
    Vue.models = models
    Vue.prototype.serverUrl = serverUrl
  },
  $models: models
}

export const $models = models



// WEBPACK FOOTER //
// ./src/models/index.js